import type {
  AutomationCancellationPolicy,
  AutomationSource,
  CancelledAutomationTaskPolicy,
} from "./types";

export const DEFAULT_CANCELLED_AUTOMATION_TASK_POLICY: CancelledAutomationTaskPolicy =
  "suppress_occurrence";

export const CANCELLED_AUTOMATION_TASK_POLICY_LABELS: Record<
  CancelledAutomationTaskPolicy,
  string
> = {
  suppress_occurrence: "Do not recreate canceled automated tasks",
  none: "Allow automation to recreate canceled tasks",
};

export const AUTOMATION_SOURCE_LABELS: Record<AutomationSource, string> = {
  manual: "Manual",
  service_cadence: "Service cadence",
  revenue_threshold: "Revenue threshold",
  cash_threshold: "Cash threshold",
  card_threshold: "Card threshold",
  inventory_threshold: "Inventory threshold",
  commission_threshold: "Commission threshold",
};

export const AUTOMATION_CANCELLATION_POLICY_LABELS: Record<
  AutomationCancellationPolicy,
  string
> = {
  none: "None",
  suppress_occurrence: "Suppress this occurrence",
};

export const automationSourceLabel = (source?: AutomationSource | null) =>
  source ? AUTOMATION_SOURCE_LABELS[source] : "Manual";

export const automationCancellationPolicyLabel = (
  policy?: AutomationCancellationPolicy | null,
) => (policy ? AUTOMATION_CANCELLATION_POLICY_LABELS[policy] : "None");

export const cancelledAutomationTaskPolicyLabel = (
  policy?: CancelledAutomationTaskPolicy | null,
) =>
  CANCELLED_AUTOMATION_TASK_POLICY_LABELS[
    policy || DEFAULT_CANCELLED_AUTOMATION_TASK_POLICY
  ];
